import React from 'react';

/**
 * Renders an icon element.
 * @param {Object} props - The component props.
 * @param {string} props.icon - The URL of the icon image.
 * @param {string} props.alt - The alt text for the icon image.
 * @param {string} props.height - The height of the icon image.
 * @param {string} props.width - The width of the icon image.
 * @returns {JSX.Element} The icon element.
 */
function IconElem({ icon, alt, height, width }) {
	if (icon?.length > 0) return <img src={icon} alt={alt} height={height} width={width} loading="lazy" />;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 32 32" className="prc__card--svg svg-icon">
			<path d="M21.5 12c-1.313-.109-3.406 4.176-4.5 3.848-.535-.16-.803-1.262-3-4-1.166-1.453-1.75-2-3.271.223-.998 1.457-5.291 4.398-5.854 4.652-.21.095-.507-.003-.875-.078v3.356h20v-4.627c-.948-1.663-1.704-3.306-2.5-3.373zm.5-3a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm6-3V2H0v22h4v4h28V6h-4zM2 22V4h24v18H2zm28 4H6v-2h22V8h2v18z"></path>
		</svg>
	);
}

/**
 * Renders a card icon component.
 * @param {Object} props - The component props.
 * @param {string} props.icon - The URL of the icon image.
 * @param {string} props.alt - The alt text for the icon image.
 * @param {string} props.height - The height of the icon image.
 * @param {string} props.width - The width of the icon image.
 * @returns {JSX.Element} The card icon component.
 */
function CardIcon(props) {
	return (
		<div className="prc__card--icon">
			<IconElem icon={props.icon} alt={props.alt} height={props.height} width={props.width} />
		</div>
	);
}

export default CardIcon;
